import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

export default function UserFormSkeleton() {
  return (
    <Box sx={{ width: '100%' }}>
      <Stack gap={2} sx={{ mb: 4 }}>
        <Stack direction="row" alignItems="center" mb={1} width="100%">
          <Skeleton variant="rounded" width={400} height={25} />
        </Stack>

        <Grid container spacing={3} size={{ xs: 10 }}>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={50} />
          </Grid>
        </Grid>
      </Stack>

      <Stack gap={2} sx={{ mb: 4 }}>
        <Stack direction="row" alignItems="center" mb={1} width="100%">
          <Skeleton variant="rounded" width={400} height={25} />
        </Stack>

        <Grid container spacing={3} size={{ xs: 6 }}>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 10 }}>
            <Skeleton variant="rounded" width={'100%'} height={50} />
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
}
